import actions from './actions';

const {
  ADD_JD_BEGIN,
  ADD_JD_SUCCESS,
  ADD_JD_ERR,

  READ_JD_BEGIN,
  READ_JD_SUCCESS,
  READ_JD_ERR,

  UPDATE_JD_BEGIN,
  UPDATE_JD_SUCCESS,
  UPDATE_JD_ERR,

  DELETE_JD_BEGIN,
  DELETE_JD_SUCCESS,
  DELETE_JD_ERR,
} = actions;

const initialState = {
  data: [],
  loading: false,
  error: null,
};

const jobDescriptionReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case ADD_JD_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case ADD_JD_SUCCESS:
      return {
        ...state,
        error: false,
        loading: false,
      };

    case ADD_JD_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    case READ_JD_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case READ_JD_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case READ_JD_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    case DELETE_JD_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case DELETE_JD_SUCCESS:
      return {
        ...state,
        error: false,
        data,
        loading: false,
      };

    case DELETE_JD_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    case UPDATE_JD_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case UPDATE_JD_SUCCESS:
      return {
        ...state,
        error: false,
        loading: false,
      };

    case UPDATE_JD_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};

export { jobDescriptionReducer };
